import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import MessageDetailsShape from 'app/shapes/MessageDetailsShape';

import ModalsContext from 'app/contexts/ModalsContext';
import DialogsContext from 'app/contexts/DialogsContext';

import LeaveFeedbackModalContainer from 'app/containers/modals/LeaveFeedbackModalContainer';
import TributeWorkflowContainer from 'app/containers/modals/tributes/TributeWorkflowContainer';
import BilledRecipientDialog from 'app/features/mail/components/message_details/BilledRecipientDialog';

import {
  Box,
  Stack,
} from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import MessageChip from 'app/features/mail/components/MessageChip';

const paidChip = (
  <MessageChip
    copy="Paid"
    sx={{
      backgroundColor: '#67ac5b;',
      color: 'white',
    }}
  />
);

const notPaidChip = (
  <MessageChip
    copy="Not Paid"
    sx={{
      backgroundColor: '#82468b',
      color: 'white',
    }}
  />
);

const PaymentStatus = ({
  messageDetails,
  currentUser,
}) => {
  const { openDialog } = useContext(DialogsContext);
  const isSender = messageDetails.sender.id === currentUser.id;
  const isRecipient = !isSender;
  const { isPaid } = messageDetails;

  const { openModal } = useContext(ModalsContext);

  const openLeaveFeedbackModalContainer = (e) => {
    e.preventDefault();
    openModal({
      component: LeaveFeedbackModalContainer,
      props: {
        objectType: 'Message',
        objectId: messageDetails.id,
      },
    });
  };

  const openTributeDialogContainer = () => {
    openDialog({
      component: TributeWorkflowContainer,
      props: {
        advisorLogin: messageDetails.sender.login,
      },
    });
  };

  const openBilledRecipientsDialog = () => {
    openDialog({
      component: BilledRecipientDialog,
      props: {
        messageId: messageDetails.id,
      },
    });
  };

  if (isRecipient && isPaid) {
    return (
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
      >
        {isPaid && paidChip}

        <>
          {isPaid && messageDetails.needsFeedback && (
            <>
              <a
                href="#"
                onClick={openLeaveFeedbackModalContainer}
              >
                Leave Feedback
              </a>
              <span>
                |
              </span>
            </>
          )}

          {isPaid && (
            <a
              href="#"
              onClick={openTributeDialogContainer}
            >
              Send Tribute
            </a>
          )}
        </>
      </Stack>
    );
  }

  if (isRecipient && !isPaid) {
    return null;
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
    >
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={1}
        direction="row"
      >
        {messageDetails.recipientCount > 1 && (
          <>
            <Box
              display="flex"
              alignItems="center"
              minHeight={24}
            >
              <AttachMoneyIcon
                sx={{
                  color: 'green',
                }}
              />
              Multiple Payments
            </Box>
            <Box
              minHeight={24}
              display="flex"
              alignItems="center"
            >
              <a
                href="#"
                onClick={openBilledRecipientsDialog}
              >
                Details
              </a>
            </Box>
          </>
        )}
        { messageDetails.recipientCount === 1 && (
          <Box
            display="flex"
            alignItems="center"
          >
            {isPaid ? paidChip : notPaidChip}
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

PaymentStatus.propTypes = {
  messageDetails: MessageDetailsShape.isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default PaymentStatus;
